import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.css']
})
export class CookieConsentComponent implements OnInit {
  showPopup: boolean = false;
  constructor() { }

  ngOnInit() {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent || consent !== "true") {
      setTimeout(() => {
        this.showPopup = true;
      }, 3000);
    }
  }

  acceptCookies() {
    localStorage.setItem('cookieConsent', "true");
    this.showPopup = false;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/shared/widgets/cookie-consent/cookie-consent.component.ts